<template>
  <div class="mdl-grid">


    <div class="mdl-card mdl-cell mdl-cell--4-col mdl-shadow--2dp">

      <figure class="mdl-card__media">
        <div style="overflow: hidden; height: 200px">
          <img src="../assets/chargingstation.jpg" style="height: 300px; width: 100%;">
        </div>
      </figure>

      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">Use case for this decentralized app</h2>
      </div>

      <div class="mdl-card__supporting-text">
          More and more electric cars are being charged between 5-7pm, the peak of energy consumption. In order to incentivize car owners to be flexible with the charging hours, they can agree with the grid operator on a 'flexible charge' for a given time, outside of peak time, and receive a bonus in exchange (tokens) from the grid operator. 
      </div>

    </div>

    <div class="mdl-card mdl-cell mdl-cell--4-col mdl-shadow--2dp">

      <figure class="mdl-card__media">
        <div style="overflow: hidden; height: 200px">
          <img src="../assets/solidity_code.jpg" style="height: 300px; width: 100%;">
        </div>
      </figure>

      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">Smart Contract</h2>
      </div>

      <div class="mdl-card__supporting-text">
        This use case can be translated into a smart contract on the Ethereum network, which makes possible:</p>
        • to create new users and new charge agreements in the blockchain,<br> 
        • and to retrieve these pieces of information from the blockchain as well.
      </div>
      
    </div>


    <div class="mdl-card mdl-cell mdl-cell--4-col mdl-shadow--2dp">

      <figure class="mdl-card__media">
        <div style="overflow: hidden; height: 200px">
          <img src="../assets/blockchain.png" style="height: 300px; width: 100%;">
        </div>
      </figure>

      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">Ethereum Blockchain</h2>
      </div>

      <div class="mdl-card__supporting-text">

        This smart contract runs actually on the Ropsten Ethereum network (via the Consensys Infura API).</p>
        
        Ropsten Ethereum, also known as “Ethereum Testnet”, is a testing network that runs the same protocol as Ethereum does and is used to testing purposes before deploying on the main network (Mainnet).

      </div>
      
    </div>

  </div>
</template>

<script>
export default {
  name: 'MainPage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.mdl-card__media {
  margin: 0;
}

.mdl-card__media > img {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/launch-page.vue